import { sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"
import ProsumerHome from "app/components/prosumer_home"
import setupLazyLoad from "app/scripts/setup_lazy_load"
import SetupUnifiedHeaderDropdown from "shared/scripts/setup_unified_header_dropdown"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"

import "stylesheets/customer.scss"

sharedVanillaSetup()

Object.assign(window.App.Scripts, {
  SetupUnifiedMobileMenu,
  ProsumerHome,
  SetupUnifiedHeaderDropdown,
  setupLazyLoad,
})
